export const categories = [
  { slug: 'romance', name: '恋爱言情', icon: 'ri-heart-line', count: 1826 },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line', count: 1247 },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', count: 1053 },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: 892 },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line', count: 765 },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line', count: 634 },
  { slug: 'bl', name: 'BL专区', icon: 'ri-user-heart-line', count: 1120 },
  { slug: 'historical', name: '古风历史', icon: 'ri-ancient-gate-line', count: 478 },
  { slug: 'school', name: '校园青春', icon: 'ri-book-open-line', count: 923 },
];

export const comics = [
  {
    id: 'comic-1',
    title: '绝世女神的贴身保镖',
    author: '金泰亨',
    category: 'action',
    categoryName: '热血动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%2C%20handsome%20male%20protagonist%20in%20black%20suit%2C%20action%20pose%20with%20dramatic%20lighting%2C%20modern%20urban%20background%2C%20dynamic%20composition%2C%20vibrant%20warm%20colors%2C%20manga%20art%20style%2C%20professional%20illustration%2C%20clean%20simple%20background%20with%20soft%20gradient%2C%20comic%20cover%20quality&width=600&height=840&seq=comic-cover-01&orientation=portrait',
    description: '顶级特工意外成为女总裁的贴身保镖，从此开启了一段惊险刺激又浪漫缠绵的都市传奇。各方势力暗流涌动，他能否守护她的安全与真心？',
    updateChapter: '第128话',
    updateTime: '2小时前',
    rating: 9.6,
    views: 1280000,
    tags: ['热血', '都市', '逆袭'],
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 'comic-2',
    title: '重生之豪门千金',
    author: '李智恩',
    category: 'romance',
    categoryName: '恋爱言情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%2C%20beautiful%20female%20character%20in%20elegant%20dress%2C%20romance%20theme%2C%20soft%20pastel%20colors%2C%20sparkling%20effects%2C%20luxurious%20background%2C%20shojo%20manga%20style%2C%20gentle%20expression%2C%20flowing%20hair%2C%20clean%20light%20gradient%20background%2C%20romantic%20atmosphere&width=600&height=840&seq=comic-cover-02&orientation=portrait',
    description: '前世被渣男贱女联手害死，重生归来她誓要夺回一切！这一世，她要让所有人都刮目相看，更要找到那个真正爱她的人。',
    updateChapter: '第95话',
    updateTime: '5小时前',
    rating: 9.8,
    views: 2560000,
    tags: ['重生', '逆袭', '豪门'],
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 'comic-3',
    title: '暗夜君王',
    author: '朴志训',
    category: 'fantasy',
    categoryName: '奇幻冒险',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%2C%20dark%20fantasy%20male%20character%20with%20sword%2C%20mysterious%20atmosphere%2C%20purple%20and%20black%20tones%2C%20magical%20aura%2C%20medieval%20fantasy%20setting%2C%20intense%20expression%2C%20dramatic%20pose%2C%20clean%20dark%20gradient%20background%2C%20epic%20fantasy%20art%20style&width=600&height=840&seq=comic-cover-03&orientation=portrait',
    description: '平凡少年意外觉醒暗夜之力，从此踏上征服世界的征途。在光明与黑暗的交锋中，他将如何抉择自己的命运？',
    updateChapter: '第210话',
    updateTime: '1天前',
    rating: 9.5,
    views: 1890000,
    tags: ['奇幻', '战斗', '升级'],
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 'comic-4',
    title: '办公室恋情禁止令',
    author: '郑秀妍',
    category: 'romance',
    categoryName: '恋爱言情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%2C%20office%20romance%20theme%2C%20handsome%20male%20and%20beautiful%20female%20characters%2C%20modern%20office%20setting%2C%20warm%20cozy%20colors%2C%20professional%20attire%2C%20romantic%20tension%2C%20clean%20light%20background%2C%20k-drama%20vibe%2C%20sweet%20atmosphere&width=600&height=840&seq=comic-cover-04&orientation=portrait',
    description: '冷面上司和热情下属的秘密办公室恋情，明明禁止却无法抗拒的吸引力。公司规定是死的，但心动是活的！',
    updateChapter: '第72话',
    updateTime: '3小时前',
    rating: 9.4,
    views: 890000,
    tags: ['职场', '甜蜜', '恋爱'],
    isHot: false,
    isNew: true,
    isCompleted: false,
  },
  {
    id: 'comic-5',
    title: '我的室友不是人',
    author: '吴世勋',
    category: 'comedy',
    categoryName: '搞笑日常',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%2C%20comedy%20theme%2C%20funny%20characters%20with%20exaggerated%20expressions%2C%20supernatural%20elements%2C%20bright%20colorful%20style%2C%20apartment%20setting%2C%20ghost%20character%20design%2C%20humorous%20atmosphere%2C%20clean%20simple%20background%20with%20warm%20gradient&width=600&height=840&seq=comic-cover-05&orientation=portrait',
    description: '搬进便宜公寓的第一天，就发现室友是个千年鬼魂！从此鸡飞狗跳的同居生活开始了，笑料百出却又温暖人心。',
    updateChapter: '第156话',
    updateTime: '8小时前',
    rating: 9.3,
    views: 1560000,
    tags: ['搞笑', '灵异', '日常'],
    isHot: false,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 'comic-6',
    title: '深渊凝视',
    author: '崔珉豪',
    category: 'thriller',
    categoryName: '悬疑惊悚',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20thriller%20illustration%2C%20dark%20mysterious%20atmosphere%2C%20silhouette%20in%20shadow%2C%20red%20accents%2C%20psychological%20horror%20theme%2C%20intense%20mood%2C%20noir%20style%2C%20suspenseful%20composition%2C%20clean%20dark%20gradient%20background%2C%20mystery%20and%20suspense&width=600&height=840&seq=comic-cover-06&orientation=portrait',
    description: '连环失踪案的背后，隐藏着一个令人不寒而栗的真相。当深渊凝视着你的时候，你会选择逃避还是直面恐惧？',
    updateChapter: '第45话',
    updateTime: '1天前',
    rating: 9.7,
    views: 670000,
    tags: ['悬疑', '推理', '惊悚'],
    isHot: false,
    isNew: true,
    isCompleted: false,
  },
  {
    id: 'comic-7',
    title: '甜心教官',
    author: '韩素希',
    category: 'school',
    categoryName: '校园青春',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20illustration%2C%20young%20couple%20in%20school%20uniforms%2C%20cherry%20blossom%20atmosphere%2C%20spring%20vibes%2C%20youthful%20energy%2C%20bright%20warm%20colors%2C%20campus%20background%2C%20sweet%20romantic%20moment%2C%20clean%20soft%20gradient%20background&width=600&height=840&seq=comic-cover-07&orientation=portrait',
    description: '转学第一天遇到魔鬼教官，却不知他是全校女生心中的白马王子。训练场上的汗水与心动，青春的甜蜜烦恼。',
    updateChapter: '第88话',
    updateTime: '6小时前',
    rating: 9.2,
    views: 1120000,
    tags: ['校园', '甜宠', '青春'],
    isHot: false,
    isNew: false,
    isCompleted: true,
  },
  {
    id: 'comic-8',
    title: '血族契约',
    author: '金南俊',
    category: 'bl',
    categoryName: 'BL专区',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20vampire%20theme%20illustration%2C%20two%20handsome%20male%20characters%2C%20dark%20gothic%20atmosphere%2C%20vampire%20aesthetic%2C%20red%20and%20black%20color%20scheme%2C%20mysterious%20romantic%20tension%2C%20elegant%20style%2C%20clean%20dark%20gradient%20background%2C%20dramatic%20lighting&width=600&height=840&seq=comic-cover-08&orientation=portrait',
    description: '为救重病的妹妹，他与血族签订了契约。冰冷的獠牙和炽热的情感，在永夜的世界里交织成一曲不灭的恋歌。',
    updateChapter: '第67话',
    updateTime: '4小时前',
    rating: 9.6,
    views: 980000,
    tags: ['BL', '吸血鬼', '契约'],
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 'comic-9',
    title: '大航海时代',
    author: '张东健',
    category: 'historical',
    categoryName: '古风历史',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20adventure%20illustration%2C%20pirate%20captain%20character%2C%20naval%20battle%20background%2C%20epic%20ocean%20setting%2C%20ancient%20Korean%20navy%20aesthetic%2C%20dramatic%20seascape%2C%20warm%20golden%20sunset%20colors%2C%20adventure%20theme%2C%20clean%20atmospheric%20background&width=600&height=840&seq=comic-cover-09&orientation=portrait',
    description: '朝鲜王朝末期，一个少年踏上远航之路。在惊涛骇浪中，他将书写属于自己的海洋传奇！',
    updateChapter: '第134话',
    updateTime: '2天前',
    rating: 9.4,
    views: 750000,
    tags: ['历史', '冒险', '航海'],
    isHot: false,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 'comic-10',
    title: '都市灵异事件簿',
    author: '申敏儿',
    category: 'drama',
    categoryName: '都市剧情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20fantasy%20illustration%2C%20female%20detective%20character%2C%20modern%20city%20night%20setting%2C%20supernatural%20elements%2C%20neon%20lights%2C%20mysterious%20atmosphere%2C%20noir%20detective%20style%2C%20cool%20urban%20vibe%2C%20clean%20dark%20gradient%20background&width=600&height=840&seq=comic-cover-10&orientation=portrait',
    description: '在灯红酒绿的都市中，有一群专门处理灵异事件的专家。每个案子背后，都藏着人心最深处的秘密。',
    updateChapter: '第56话',
    updateTime: '10小时前',
    rating: 9.1,
    views: 540000,
    tags: ['都市', '灵异', '探案'],
    isHot: false,
    isNew: true,
    isCompleted: false,
  },
  {
    id: 'comic-11',
    title: '傲娇少爷爱上我',
    author: '林允儿',
    category: 'romance',
    categoryName: '恋爱言情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20rich%20boy%20romance%20illustration%2C%20handsome%20wealthy%20male%20lead%2C%20elegant%20mansion%20background%2C%20luxury%20aesthetic%2C%20romantic%20comedy%20vibe%2C%20warm%20golden%20lighting%2C%20shojo%20style%2C%20clean%20soft%20gradient%20background%2C%20sweet%20atmosphere&width=600&height=840&seq=comic-cover-11&orientation=portrait',
    description: '平凡女孩意外住进豪门少爷的家里，两个世界的碰撞擦出了意想不到的火花。他的高傲是伪装，她的温柔是解药。',
    updateChapter: '第112话',
    updateTime: '7小时前',
    rating: 9.5,
    views: 2100000,
    tags: ['豪门', '傲娇', '甜宠'],
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 'comic-12',
    title: '末日后 survival',
    author: '金钟国',
    category: 'action',
    categoryName: '热血动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20illustration%2C%20survival%20action%20theme%2C%20ruined%20city%20background%2C%20male%20survivor%20character%2C%20desolate%20atmosphere%2C%20warm%20orange%20and%20gray%20tones%2C%20action%20pose%2C%20dramatic%20composition%2C%20clean%20gradient%20background&width=600&height=840&seq=comic-cover-12&orientation=portrait',
    description: '末日降临，文明崩塌。在废墟之中，他带领幸存者们艰难求生，而更大的阴谋正悄然展开……',
    updateChapter: '第189话',
    updateTime: '12小时前',
    rating: 9.3,
    views: 1430000,
    tags: ['末日', '生存', '战斗'],
    isHot: false,
    isNew: false,
    isCompleted: false,
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '林小曼',
    role: '资深韩漫读者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20natural%20beauty%2C%20soft%20makeup%2C%20warm%20gentle%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting%2C%20friendly%20approachable%20look&width=300&height=300&seq=testimonial-01&orientation=squarish',
    quote: '这个网站真的太棒了！我追韩漫已经三年多了，这里的更新速度是最快的，而且免费就能看全部章节，画质也非常清晰，下拉式阅读超级方便。',
    rating: 5,
  },
  {
    id: 't2',
    name: '陈子涵',
    role: '漫画爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%2C%20modern%20stylish%20look%2C%20friendly%20smile%2C%20casual%20fashion%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20natural%20lighting%2C%20warm%20approachable%20expression&width=300&height=300&seq=testimonial-02&orientation=squarish',
    quote: '分类特别全，想看的韩漫这里基本都有。而且界面设计很舒服，阅读体验一流。每天打开都能看到新鲜的更新，推荐给了好多朋友！',
    rating: 5,
  },
  {
    id: 't3',
    name: '张悦然',
    role: '自由插画师',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20artistic%20portrait%2C%20creative%20style%2C%20warm%20smile%2C%20beret%20hat%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20natural%20soft%20lighting%2C%20friendly%20vibe&width=300&height=300&seq=testimonial-03&orientation=squarish',
    quote: '作为从业者，我对画质要求很高。韩漫网的画质完全没话说，加载速度也快。最喜欢的是下拉式阅读模式，一口气看几十话完全不累。',
    rating: 5,
  },
];

export const stats = [
  { label: '收录漫画', value: '5000+' },
  { label: '每日更新', value: '200+' },
  { label: '累计读者', value: '800万+' },
  { label: '月阅读量', value: '2亿+' },
];

export const faqs = [
  {
    question: '韩国漫画网的所有漫画都是免费的吗？',
    answer: '是的！韩国漫画网（韩漫大全）所有漫画内容完全免费，无需付费即可畅读全部章节。我们致力于为广大韩漫爱好者提供优质的免费阅读体验。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是我们为移动端和PC端优化的阅读体验。您只需向下滚动页面即可连续阅读，无需翻页，就像刷社交媒体一样自然流畅，让您沉浸在漫画世界中。',
  },
  {
    question: '网站多久更新一次漫画内容？',
    answer: '我们每日更新漫画内容，确保您能第一时间看到最新的章节。热门连载漫画通常会在原版发布后的数小时内同步更新。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过首页的搜索框输入漫画名称或作者名进行搜索，也可以点击分类浏览，按题材（恋爱、动作、奇幻等）找到感兴趣的漫画。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '我们的网站完美适配PC、平板和手机端，无论使用什么设备都能获得流畅的阅读体验。推荐使用手机端获得最佳的下拉式阅读感受。',
  },
  {
    question: '可以下载漫画离线观看吗？',
    answer: '目前我们仅支持在线阅读，建议将我们加入浏览器收藏夹，随时随地打开就能看。在线阅读能确保您看到的是最新最清晰的版本。',
  },
];